import { ColorPaletteType, ThemeColorsType, ThemeTailwindType } from 'src/domains/common/themeColors';

export const properbetColors: ThemeTailwindType = {
    '--primary': '166 63% 47%',
    '--menu-primary': '0 0% 100%',
    '--menu-secondary': '0 0% 100%',
};

const colorPalette: ColorPaletteType = {
    primary: '#132742',
    secondary: '#2CC4A0',
    tertiary: '#EDE8DC',
    dark: '#0B1627',
    shade1: '#1C375C',
    shade2: '#EDE8DC',
    shade3: '#F2EEE4',
    shade4: '#F6F3EC',
    shade5: '#FAF8F4',
    shade6: '#F9F9F6',
    textDark: '#0F1D43',
    white: '#FFFFFF',
};

export const themeColors: ThemeColorsType = {
    header: {
        bgColor: colorPalette.dark,
        bgColorSecondary: colorPalette.primary,
        bgColorTertiary: colorPalette.secondary,
        bgColorQuaternary: colorPalette.secondary,

        borderColor: colorPalette.secondary,
        borderColorSecondary: colorPalette.secondary,

        txtColor: colorPalette.white,
        txtColorSecondary: colorPalette.secondary,
        txtColorTertiary: colorPalette.dark,
        txtColorQuaternary: colorPalette.white,
    },
    buttons: {
        bgColor: colorPalette.secondary,
        txtColor: colorPalette.dark,
    },
    input: {
        bgColor: colorPalette.shade6,
    },
    colorPicker: {
        colors: colorPalette,
        bgDefault: colorPalette.shade1,
        txtDefault: colorPalette.white,
    },
    anniversaryModal: {
        bgColor: '',
        bgColorSecondary: '',
        bgColorTertiary: '',
        txtColor: '',
        txtColorSecondary: '',
        txtColorTertiary: '',
    },
    loginPage: {
        bgColor: colorPalette.secondary,
    },
    traderChat: {
        bgColor: colorPalette.white,
        borderColor: '#d6e6f2',
        borderColorSecondary: '#ccc',
        txtColor: '#888',
    },
    compliancePopup: {
        bgColor: '#0B1627',
        txtColor: '#FDFDFB',
        bodyTxtColor: 'rgba(253, 253, 251, 0.8)',
        buttonBgColor: '#2CC4A0',
        buttonTxtColor: '#0B1627',
        secondaryBtnBgColor: 'rgba(253, 253, 251, 0.1)',
    },
};
